import { render, staticRenderFns } from "./PermitApplicationForm.vue?vue&type=template&id=c3dd3616&scoped=true"
import script from "./PermitApplicationForm.vue?vue&type=script&lang=js"
export * from "./PermitApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./PermitApplicationForm.vue?vue&type=style&index=0&id=c3dd3616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dd3616",
  null
  
)

export default component.exports